import React from 'react';
import styled from 'styled-components';

import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';

const SidebarPanel = (props: React.PropsWithChildren) => {
    return (
        <FloatingEl>
            <Slide direction={'right'} in={true}>
                <Paper
                    sx={{
                        height: '100%',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        borderRadius: '8px',
                    }}
                >
                    {props.children}
                </Paper>
            </Slide>
        </FloatingEl>
    );
};

const FloatingEl = styled.div`
    z-index: 1;
    width: 300px;
    pointer-events: none;
    background-color: transparent;
    padding: 4px;
    grid-column: sidebar-start / sidebar-end;
    grid-row: top / bottom;
    overflow: hidden;

    /* Allow pointer events only on child elements */
    & > * {
        pointer-events: all;
    }

    @media (max-width: 1452px) {
        grid-row: top / segment-details-top;
        min-height: 300px;
        overflow: visible;
    }
`;

export default SidebarPanel;
